import { defineCustomElement } from 'vue'
import Picker from './Picker.vue'

// import Picker from './components/Picker.vue'

import { VueFire, VueFireAuth } from 'vuefire'
import { initialize } from '../helpers/firebase'
const firebaseApp = initialize()

const PickerCustomElement = defineCustomElement(Picker, {
  configureApp: (app) => {
    app.use(VueFire, {
      firebaseApp,
      modules: [VueFireAuth()],
    })
  },
})

export default class ExtendedPicker extends PickerCustomElement {
  constructor() {
    super()

    const input = document.createElement('input')
    input.type = 'text'
    input.name = 'bundle-id'
    input.id = 'bundle-id'
    this.appendChild(input)

    const shadowRoot = this.shadowRoot

    if (shadowRoot) {
      shadowRoot.addEventListener('picker-confirm', (e) => {
        if (e.target) {
          const targetElement = e.target as HTMLInputElement
          if (targetElement.value) {
            input.value = targetElement.value
          }
        }
      })
    }
  }
}
